var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('router-link',{attrs:{"to":"/customer"}},[_vm._v("顧客")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }